import * as React from 'react';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { getOrgTransactions, setTransactionsCurrentPage } from '~/apps/shared/actions/transactions';
import TransactionListTable from '../../components/transactions/TransactionListTable';
import { defaultTablePageSize } from '~/common/components/consts';

class TransactionList extends React.Component<any, any> {
  componentDidUpdate = (prevProps) => {
    if (prevProps.filter && this.props.filter) {
      if (!_.isEqual(prevProps.filter, this.props.filter)) {
        // TODO: Paging should be controlled by the component
        this.onFetchData({page: 0, pageSize: defaultTablePageSize}, null);
      }
    }
  };

  onFetchData = (state, instance) => {
    const { orgId, dispatch, filter } = this.props;
    dispatch(getOrgTransactions(orgId, filter, state.page * state.pageSize));
  };

  onClick = (model) => {
    this.props.onClick(model.id);
  };

  onPageChange = (page) => {
    const { dispatch } = this.props;

    dispatch(setTransactionsCurrentPage(page));
  };

  render() {
    const { transactions, organizations, locations, showOrganization, orgId } = this.props;

    return (
      <TransactionListTable
        manual={true}
        orgId={orgId}
        loading={transactions.ui.loading}
        page={transactions.ui.currentPage}
        data={transactions.ui.currentList.map(u => transactions.entities[u])}
        getOrganization={(id) => organizations.entities[id]}
        getLocation={(id) => locations.entities[id]}
        onFetchData={this.onFetchData}
        onClick={this.onClick}
        onPageChange={this.onPageChange}
        showOrganization={showOrganization}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactions: state.shared.transactions,
    organizations: state.shared.organizations,
    locations: state.shared.locations,
  }
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionList);
